<template lang="pug">
v-container.pa-sm-8
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text Segments
  v-row(no-gutters)
    v-col(cols="12" sm="6")
      .d-flex.align-center
        v-text-field.round-lg.search-input(v-model="searchText" @input="queryChanged" :placeholder="$t('search_segments')" hide-details dense solo flat height="40" :background-color="$colors.basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$colors.primary400")
    v-col(cols="12" md="6")
      .d-flex.align-center.justify-end
        yc-pagination-custom.ml-4(v-model="page" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_segments')" attach @input="pageChanged")
  v-row(align="center" v-if="!isMobileScreen")
    v-col(cols="12")
      .d-flex.align-center
        v-btn.button-Aa-small.mr-3(v-if="selectedSegments.length" @click="showDeleteDialog = true" color="danger500" height="32" outlined depressed) {{ $t('delete') }}
        a.link-s(v-if="selectedSegments.length" @click="clearSelection") {{ $t('clear_selection') }}
  div.mt-4(v-else)
    v-divider
    .d-flex.align-center.py-3
      yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      v-menu(v-if="selectedSegments.length" offset-y)
        template(v-slot:activator="{ on, attrs }")
          v-btn.button-Aa-small(v-on="on" text height=32) Action ({{ selectedSegments.length }})
            v-icon.ml-1(small) mdi-chevron-down
        v-list
          v-list-item(@click="showDeleteDialog = true")
            .p2.danger500--text {{ $t('delete') }}
          v-list-item(@click="clearSelection")
            .p2 {{ $t('clear_selection') }}
      v-spacer
      yc-pagination(v-model="page" :pageSize="pageSize" :count="totalCount")
    v-divider
  .yc-table
    v-data-table.mt-4(:headers="headers" :items="segments" :items-per-page="pageSize" :hide-default-header="isMobileScreen" item-key="id" hide-default-footer disable-sort :loading="isLoading" loader-height="2")
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_segments_available') }}
      template(v-slot:header.checked)
        yc-checkbox(v-model="checkAll" @change="onCheckedAll")
      template(v-slot:item="{ item, isMobile, headers, index }")
        tr.primary--text(v-if="!isMobile")
          td(v-for="header in headers")
            template(v-if="header.value === 'checked'")
              yc-checkbox(v-model="item.checked" @change="onChecked")
            template(v-if="header.value === 'title'")
              a.text-sm.font-medium.info500--text(@click="openDetail(item)") {{ item.title }}
            template(v-if="header.value === 'customer'")
              div {{ item.customer.length }}
            template(v-if="header.value === 'created'")
              div {{ item.created | convertServerDate }}
            template(v-if="header.value === 'enabled'")
              .d-flex.mt-3
                v-spacer
                div
                  y-switch(v-model="item.enabled" @change="onToggle(item)" :disabled="!item.enabled && reachGroupCountLimit")
                v-spacer
        template(v-else)
          .d-flex.py-3.align-start
            yc-checkbox(v-model="item.checked" @change="onChecked")
            .ml-4.flex-grow-1
              a.text-sm.font-medium.info500--text(@click="openDetail(item)") {{ item.title }}
              template(v-for="header in headers")
                .d-flex.mb-1.p1(v-if="header.value !== 'checked' && header.value !== 'title'")
                  .flex-grow-1
                    .basic600--text {{ header.text }}
                  div(v-if="header.value === 'customer'") {{ item.customer.length }}
                  div(v-else-if="header.value === 'created'") {{ item.created | convertServerDate }}
                  div(v-else-if="header.value === 'enabled'")
                    y-switch.mb-n2.mr-n2(v-model="item.enabled" @change="onToggle(item)" :disabled="!item.enabled && reachGroupCountLimit")
                  div(v-else) {{ item[header.value] }}
          v-divider
    .yc-fixed-bottom-section(v-if="isMobileScreen")
      yc-pagination-custom(v-model="page" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('show_segments')" @input="pageChanged")
  create-segment-dialog(v-if="showCreateDialog" :open.sync="showCreateDialog" :os="os")
  delete-segment-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :segments="selectedSegments" @deleted="onDeleted")
</template>

<script>
import { debounce } from '@/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
import CreateSegmentDialog from '@/components/module/segment/CreateSegmentDialog.vue'
import DeleteSegmentDialog from '@/components/module/segment/DeleteSegmentDialog.vue'

export default {
  components: { CreateSegmentDialog, DeleteSegmentDialog },
  data: () => ({
    checkAll: false,
    searchText: '',
    page: 1,
    pageSize: 20,
    totalCount: 0,
    selected: [],
    headers: [
      {
        text: '',
        value: 'checked'
      },
      {
        text: 'Name',
        value: 'title'
      },
      {
        text: 'Patient count',
        value: 'customer'
      },
      {
        text: 'Created on',
        value: 'created'
      }
    ],
    segments: [],
    selectedSegments: [],
    isLoading: true,
    showDeleteDialog: false,
    showCreateDialog: false,
    activeGroupCount: 0,
    os: 'clinic'
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    ...mapState('subscriptions', ['connectSubscription']),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    },
    reachGroupCountLimit() {
      return false
    }
  },
  watch: {
    pageSize() {
      this.fetchSegments(1)
    },
  },
  created() {
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchSegments(1)
    this.fetchActiveGroupCount()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSegments(page, query) {
      this.isLoading = true
      const params = {
        page_size: this.pageSize,
        page,
        search: query || '',
        dynamic: false,
        ordering: '-id'
      }
      this.$axios.get(`/connect/${this.company.slug}/groups`, { params })
      .then(resp => {
        const data = resp.data
        this.segments = data.results
        this.totalCount = data.count
      })
      .catch(() => {
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    updateEnableStatus(item) {
      const params = {
        enabled: item.enabled
      }
      this.$axios.patch(`/connect/${this.company.slug}/groups/${item.id}`, params)
      .then(() => {
        const message = item.enabled ? this.$t('success_message.segment_shown_at_tab') : this.$t('success_message.segment_not_shown_at_tab')
        this.updateActiveGroupCount(item.enabled)
        this.showMessage(['success', message])
      })
      .catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
      .finally(() => {
      })
    },
    fetchActiveGroupCount() {
      this.$axios.get(`/connect/${this.company.slug}/settings`)
      .then(resp => {
        this.activeGroupCount = resp.data.active_group_count
      })
      .catch(() => {})
    },
    onToggle(item) {
      this.updateEnableStatus(item)
    },
    openDetail(item) {
      this.$router.push(`/admin/clinic/segments/${item.id}`)
    },
    onChecked() {
      this.selectedSegments = this.segments.filter(item => item.checked === true)
      this.segments = [...this.segments]
      this.checkAll = false
    },
    onCheckedAll() {
      const clone = [...this.segments]
      clone.map(item => item.checked = this.checkAll)
      this.segments = [...clone]
      this.selectedSegments = this.segments.filter(item => item.checked === true)
    },
    pageChanged(num) {
      this.fetchSegments(num)
    },
    queryChanged: debounce(function (query) {
      this.fetchSegments(1, query)
    }, 750),
    clearSelection() {
      this.checkAll = false
      this.onCheckedAll()
    },
    newSegment() {
      this.showCreateDialog = true
    },
    onDeleted() {
      this.clearSelection()
      this.fetchSegments(1)
    },
    updateActiveGroupCount(status) {
      if (status) {
        this.activeGroupCount++
      } else {
        this.activeGroupCount--
      }
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
  }
}
</script>
